<template>
  <div>
    <label>Prestador</label>
    <v-autocomplete
      v-model="prestadorId"
      :items="prestadores"
      :search-input.sync="searchInput"
      item-value="id"
      item-text="prest_nome"
      label="Selecione"
      chips
      outlined
      flat
      solo
      dense
      filled
      :rules="formRules.required"
    >
      <template v-slot:selection="data">
        <v-chip  small label class="ma-1" style="max-width: 90%">
          {{ data.item.prest_nome }}
        </v-chip>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    value: Number
  },
  model: {
    props: 'value',
    event: 'change'
  },
  data: function () {
    return {
      prestadores: this.$store.getters['permissions/getPrestadoresByGeco'](),
      searchInput: ''
    }
  },
  computed: {
    ...mapState({
      formRules: state => state.formRules
    }),
    prestadorId: {
      get: function () {
        return this.value
      },
      set: function (val) {
        this.$emit('change', val)
      }
    }
  },
  mounted: function () {
    if (this.prestadores.length === 1) {
      this.prestadorId = this.prestadores[0].id
    }
  }
}
</script>
